import SourceToken from '@admin/tokens/source'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {}

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      title: 't(New Affilate)',
      method: 'POST',
      action: '/api/admin/truevail/admin/affiliates',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Team)',
              type: 'segment',
              fields: [
                {
                  type: 'radiogroup',
                  name: 'strategy',
                  options: [
                    { value: 'team', text: 't(Choose existing team)' },
                    { value: 'new', text: 't(Create new team)' }
                  ],
                  defaultValue: 'team'
                },
                { 
                  entity: 't(Team)', 
                  name: 'team_id', 
                  type: 'lookup', 
                  endpoint: '/api/admin/truevail/admin/advisors', 
                  sort: { key: 'title', order: 'asc' },
                  filter: { status: { $eq: 'active' } },
                  valueKey: 'team.id',
                  textKey: 'team.title', 
                  show: config.strategy === 'team',
                  required: true 
                },
                {
                  label: 't(First Name)',
                  name: 'first_name',
                  type: 'textfield',
                  show: config.strategy === 'new',
                  required: true
                },
                {
                  label: 't(Last Name)',
                  name: 'last_name',
                  type: 'textfield',
                  show: config.strategy === 'new',
                  required: true
                },
                {
                  label: 't(Organization)',
                  name: 'organization',
                  type: 'textfield',
                  show: config.strategy === 'new',
                  required: true
                },
                {
                  label: 't(Email)',
                  name: 'email',
                  type: 'textfield',
                  show: config.strategy === 'new',
                  required: true
                },
                { 
                  label: 't(Public Domain)', 
                  name: 'public_domain', 
                  type: 'domainfield',
                  provider_id: 2,
                  show: config.strategy === 'new',
                  required: true,
                  defaultValue: process.env.MAHA_ENV === 'development' ? '.local.trvlpost.com' : '.trvlpost.com'
                },
                { 
                  label: 't(Timezone)', 
                  name: 'timezone_id', 
                  type: 'lookup', 
                  endpoint: '/api/admin/timezones', 
                  valueKey: 'id', 
                  textKey: 'zone', 
                  show: config.strategy === 'new',
                  required: true, 
                  defaultValue: 172 
                }
              ]
            },
            { 
              label: 't(Bank)', 
              type: 'segment',
              fields: [
                {
                  name: 'service',
                  type: 'radiogroup',
                  options: [
                    { source_name: 'paypal', name: 'Paypal' },
                    { source_name: 'venmo', name: 'Venmo' }
                  ],
                  format: (source) => <SourceToken source={ source } />,
                  valueKey: 'source_name',
                  defaultValue: 'paypal',
                  required: true
                },
                {
                  label: 't(Paypal Email)',
                  name: 'service_id',
                  type: 'emailfield',
                  show: config.service === 'paypal',
                  required: true
                },
                {
                  label: 't(Venmo Username)',
                  name: 'service_id',
                  type: 'textfield',
                  show: config.service === 'venmo',
                  required: true
                }
              ]
            },
            { 
              label: 't(Commission Rate)', 
              name: 'rate', 
              type: 'ratefield',
              required: true,
              defaultValue: 0.1,
              precision: 2
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess(post) {
    this.context.modal.close()
  }

}

export default New
